export const NotFound = () => (
  <div className="text-center py-20">
    <h1 className="text-4xl font-bold">404 - Not Found</h1>
    <p className="text-lg text-slate-500 mt-4">The page you are looking for does not exist.</p>
  </div>
);
